import { render, staticRenderFns } from "./DailyComponent.vue?vue&type=template&id=dedb8616&scoped=true"
import script from "./DailyComponent.vue?vue&type=script&lang=js"
export * from "./DailyComponent.vue?vue&type=script&lang=js"
import style0 from "./DailyComponent.vue?vue&type=style&index=0&id=dedb8616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dedb8616",
  null
  
)

export default component.exports